import { createAPI } from '@common'

export default {
  // 新建投票
  postNisVote: config => createAPI('customEncryptApiName-1/0w20ojt0wpuf', 'post', config),
  // 获取投票详情
  getNisVote: config => createAPI('customEncryptApiName-1/0w20ojt0wpuf', 'get', config),
  // 修改投票信息
  putNisVote: config => createAPI('customEncryptApiName-1/0w20ojt0wpuf', 'put', config),
  // 统计结果
  getNisVoteResult: config => createAPI('customEncryptApiName-1/0w20ojt0wpuf0sftvmu', 'GET', config),
  // 统计结果
  putNisVoteOptionInitCount: config => createAPI('customEncryptApiName-1/0w20ojt0wpuf0pqujpo0jojuDpvou', 'put', config),
  // 票数清零
  putNisVoteOptionCount: config => createAPI('customEncryptApiName-1/0w20ojt0wpuf0pqujpo0dpvou', 'put', config)
}
